"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MISSING_PLACEMENT_MESSAGE = void 0;
exports.addToBasket = addToBasket;
var AddToBasketFailed = _interopRequireWildcard(require("@ori-events/add-to-basket-failed"));
var ShowLoyaltyDialog = _interopRequireWildcard(require("@ori-events/show-loyalty-dialog"));
var _checkoutUtils = require("@ori/checkout-utils");
var _logger = require("../logger");
var _convertToCamelCase = require("./convertToCamelCase");
var _getHttpRequestSettings = require("./getHttpRequestSettings");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const MISSING_PLACEMENT_MESSAGE = exports.MISSING_PLACEMENT_MESSAGE = `Missing 'placement' property in add-to-basket action data will impact reporting, please contact your SE.`;
async function addToBasket(url, params, buyingMethod) {
  const {
    itemCode,
    placement,
    quantity
  } = params;
  if (placement === undefined) {
    (0, _logger.logWarning)(MISSING_PLACEMENT_MESSAGE);
  }
  const response = await fetch(url, (0, _getHttpRequestSettings.getHttpRequestSettings)(params, _checkoutUtils.HttpMethod.Post));
  const data = (0, _convertToCamelCase.convertToCamelCase)(await response.json());
  if (AddToBasketFailed.isAddToBasketErrorResponse(data)) {
    const event = new CustomEvent(AddToBasketFailed.Name, {
      detail: data
    });
    window.dispatchEvent(event);
    return false;
  }
  if (AddToBasketFailed.isAddToBasketLoyaltyResponse(data)) {
    const event = new CustomEvent(ShowLoyaltyDialog.Name, {
      detail: {
        ...data,
        itemCode,
        placement,
        quantity
      }
    });
    window.dispatchEvent(event);
    return false;
  }
  return {
    ...data,
    lastAddedItem: {
      itemCode,
      method: buyingMethod,
      quantity
    }
  };
}
